// extracted by mini-css-extract-plugin
export var chip = "_mv-2";
export var chipBody = "_mv-8";
export var chipHeader = "_mv-9";
export var chipWithKind = "_mv-7";
export var icon = "_mv-3";
export var kind = "_mv-a";
export var remove = "_mv-5";
export var removeIcon = "_mv-6";
export var row = "_mv-0";
export var rowHistorical = "_mv-1";
export var text = "_mv-4";